import { stockStatus } from './constants';
import { EVENT_NAME_FOR_PRODUCT_LIST } from '../../../packs/shop/constants/tracker';

export const sendRecommendItem = ({
  productId,
  relatedProductId,
  order,
  recStrategy,
  trackerService,
  layoutSetting,
  pageType,
}) => {
  const params = {
    // product_id means the PDP which the user is redirected to.
    product_id: relatedProductId,
    rank: order,
    layout_setting: layoutSetting,
    page_type: pageType,
    // PDP will pass productId
    ...(productId && { based_product_id: productId }),
    ...(recStrategy && { rec_strategy: recStrategy }),
  };
  trackerService?.track(EVENT_NAME_FOR_PRODUCT_LIST.RecommendItem, params);
};

export const sendViewRelatedProducts = ({
  relatedProduct,
  productId,
  order,
  trackerService,
  layoutSetting,
  pageType,
}) => {
  trackerService?.track(EVENT_NAME_FOR_PRODUCT_LIST.ViewRelatedProducts, {
    product_infos: [
      {
        id: relatedProduct.id,
        status: relatedProduct.sold_out
          ? stockStatus.OUT_OF_STOCK
          : stockStatus.IN_STOCK,
        rank: order,
        layout_setting: layoutSetting,
        page_type: pageType,
        // PDP will pass productId
        ...(productId && { based_product_id: productId }),
        ...(relatedProduct.rec_strategy && {
          rec_strategy: relatedProduct.rec_strategy,
        }),
      },
    ],
  });
};
